import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import './WorkSchedulePanel.css'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import LocalTimeFromInstant from 'Components/LocalTimeFromInstant/LocalTimeFromInstant';

const WorkSchedulePanel = ({
    usersSelected,
    onUpdateWorkScheduleIdSelected,
    workScheduleIdSelected
}) => {
    const [idWorkSchedule, setIdWorkSchedule] = useState(null);
    const [isSunday, setIsSunday] = useState(null);
    const [isMonday, setIsMonday] = useState(null);
    const [isTuesday, setIsTuesday] = useState(null);
    const [isWednesday, setIsWednesday] = useState(null);
    const [isThursday, setIsThursday] = useState(null);
    const [isFriday, setIsFriday] = useState(null);
    const [isSaturday, setIsSaturday] = useState(null);
    const [hoursPerDay, setHoursPerDay] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [loadingWorkSchedulePanel, setLoadingWorkSchedulePanel] = useState(null);
    const [recordsWorkScheduleByUserId, setRcordsWorkScheduleByUserId] = useState(null);
    const [attributesDetailWorkSchedulePanel, setAttributesDetailWorkSchedulePanel] = useState(null);

    const readOnlyAttributes = !(inserting || updating);

    const attributeList = [
        { name: "id", value: idWorkSchedule, setter: setIdWorkSchedule },
        {
            name: "isSunday", value: isSunday, setter: setIsSunday, checkArgument: true,
            checks: [
                { field: 'isSunday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isMonday", value: isMonday, setter: setIsMonday, checkArgument: true,
            checks: [
                { field: 'isMonday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isTuesday", value: isTuesday, setter: setIsTuesday, checkArgument: true,
            checks: [
                { field: 'isTuesday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isWednesday", value: isWednesday, setter: setIsWednesday, checkArgument: true,
            checks: [
                { field: 'isWednesday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isThursday", value: isThursday, setter: setIsThursday, checkArgument: true,
            checks: [
                { field: 'isThursday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isFriday", value: isFriday, setter: setIsFriday, checkArgument: true,
            checks: [
                { field: 'isFriday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        {
            name: "isSaturday", value: isSaturday, setter: setIsSaturday, checkArgument: true,
            checks: [
                { field: 'isSaturday', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "startTime", value: startTime, setter: setStartTime },
        { name: "endTime", value: endTime, setter: setEndTime },
        { name: "hoursPerDay", value: hoursPerDay, setter: setHoursPerDay },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        reloadListWorkSchedule()
    }, []);

    useEffect(() => {
        reloadListWorkSchedule()
        if ((!usersSelected || usersSelected.length != 1) && updating) {
            setUpdating(false)
        }

        if (!usersSelected || usersSelected.length > 1) {
            onUpdateWorkScheduleIdSelected([])
        }
    }, [usersSelected, inserting, updating]);

    useEffect(() => {
        if (workScheduleIdSelected && workScheduleIdSelected.length === 1) {
            fetchDataDetail(workScheduleIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [workScheduleIdSelected]);

    async function reloadListWorkSchedule() {
        if (usersSelected && usersSelected.length === 1) {
            await getWorkScheduleRecords(usersSelected[0])
        } else {
            await getWorkScheduleRecords(null)
        }
    }

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%'
    };

    async function getWorkScheduleRecords(userSelected) {
        const parameters = { userId: userSelected ? userSelected : 0 }
        const workSchedules = await ExecuteAxios.api('get', `/work-schedule/get-work-schedule-grid/`, { params: parameters });
        setRcordsWorkScheduleByUserId(workSchedules);
        RemoveIdsNotFound.remove(workSchedules, onUpdateWorkScheduleIdSelected, workScheduleIdSelected)
    }

    const fetchDataDetail = async (workScheduleIdSelected) => {
        const parameters = { id: workScheduleIdSelected ? workScheduleIdSelected : 0 }
        const workSchedule = await ExecuteAxios.api('get', `/work-schedule/get-work-schedule-detail/`, { params: parameters })
        if (workSchedule) {
            setAttributesDetailWorkSchedulePanel(workSchedule)
            ApplyAttributes.applyAttributes(workSchedule, attributeList)
        }

        if (!workScheduleIdSelected || workScheduleIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getWorkSchedulePanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={onUpdateWorkScheduleIdSelected}
                    idsSelected={workScheduleIdSelected}
                    data={recordsWorkScheduleByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailWorkSchedulePanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postWorkSchedule() {
        if (usersSelected && usersSelected[0]) {
            try {
                setLoadingWorkSchedulePanel(true)
                const response = await ExecuteAxios.api('post', `/work-schedule/`, {
                    userId: usersSelected[0],
                    isMonday: isMonday,
                    isTuesday: isTuesday,
                    isWednesday: isWednesday,
                    isThursday: isThursday,
                    isFriday: isFriday,
                    isSaturday: isSaturday,
                    isSunday: isSunday,
                    hoursPerDay: hoursPerDay,
                    startTime: LocalTimeFromInstant.getLocalTimeFromInstant(startTime),
                    endTime: LocalTimeFromInstant.getLocalTimeFromInstant(endTime)
                });

                if (response) {
                    await reloadListWorkSchedule()
                }
                return response
            } finally {
                setLoadingWorkSchedulePanel(false)
            }
        }
    }

    async function putWorkSchedule() {
        if (usersSelected && usersSelected[0]) {
            try {
                setLoadingWorkSchedulePanel(true)
                const response = await ExecuteAxios.api('put', `/work-schedule/`, {
                    id: idWorkSchedule,
                    userId: usersSelected[0],
                    isMonday: isMonday,
                    isTuesday: isTuesday,
                    isWednesday: isWednesday,
                    isThursday: isThursday,
                    isFriday: isFriday,
                    isSaturday: isSaturday,
                    isSunday: isSunday,
                    hoursPerDay: hoursPerDay,
                    startTime: LocalTimeFromInstant.getLocalTimeFromInstant(startTime),
                    endTime: LocalTimeFromInstant.getLocalTimeFromInstant(endTime)
                });

                if (response) {
                    await reloadListWorkSchedule()
                }
    
                return response;
            } finally {
                setLoadingWorkSchedulePanel(false)
            }
        }
    }

    async function deleteWorkSchedule() {
        if (usersSelected && usersSelected[0]) {
            try {
                setLoadingWorkSchedulePanel(true)

                const response = await ExecuteAxios.api('delete', `/work-schedule/`, {
                    params: { id: idWorkSchedule }
                });

                if (response) {
                    reloadListWorkSchedule()
                }
                return response
            } finally {
                setLoadingWorkSchedulePanel(false)
            }
        }
    }


    return (
        <LoadingIndicator loaded={!loadingWorkSchedulePanel}>
            <Panel
                style={userControlPanelStyle}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={workScheduleIdSelected && workScheduleIdSelected.length === 1}
                putFunction={putWorkSchedule}
                enableNewRecord={true}
                canNewRecord={true}
                postFunction={postWorkSchedule}
                enableDelete={true}
                canDelete={true}
                deleteFunction={deleteWorkSchedule}
                canViewCRUD={true}
                readOnly={!(usersSelected && usersSelected.length === 1)}
                recordsSelected={workScheduleIdSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailWorkSchedulePanel}
                attributeList={attributeList}
                onUpdateIdSelected={onUpdateWorkScheduleIdSelected}
            >
                {getWorkSchedulePanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}

export default WorkSchedulePanel;
